// (Bun's internal HMR runtime is minified)